import { Position } from '../types';

// Simple 2D noise function
function noise2D(x: number, y: number): number {
  const X = Math.floor(x) & 255;
  const Y = Math.floor(y) & 255;

  // Simple hash function
  const hash = (n: number) => {
    let x = Math.sin(n) * 10000;
    return x - Math.floor(x);
  };

  return hash(X + Y * 157) * 2 - 1;
}

// Smooth noise using multiple octaves
function smoothNoise(x: number, y: number, scale = 0.1): number {
  const octaves = 4;
  let value = 0;
  let amplitude = 1;
  let frequency = 1;
  let maxValue = 0;

  for (let i = 0; i < octaves; i++) {
    value += noise2D(x * frequency * scale, y * frequency * scale) * amplitude;
    maxValue += amplitude;
    amplitude *= 0.5;
    frequency *= 2;
  }

  return value / maxValue;
}

export function getTileType(worldPos: Position): 'land' | 'water' {
  const noiseValue = smoothNoise(worldPos.x, worldPos.y);
  return noiseValue > -0.2 ? 'land' : 'water';
}
